import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { trans, setBracketsAfterFirstPart } from '../../../helpers';
import config from '../../../baseConfig';
import { localStorageGetItem } from '../../../storage';
import Loading from '../../Fragments/Loading';
import B2bCtnView from './B2bCtnView';
import ApiManager from '../../../apiManager';
import ReactNotification from 'react-notifications-component';
import B2bInfoList from '../../Fragments/B2bInfoList';

class B2bBanInfo extends Component {

    constructor( props ){
        super( props );

        this.state = {
            filterVal: '',
            filterValForSearch: '',
            scrollShowItemsDef: 20,
            scrollShowItems: 20,
            scrollLimit: 10,
            scrollItemCount: 0,
            checkAllCtn: false,
            checkedItemCount: 0,
            checkedItems: {}
        };

        // Component props
        this.componentIsMounted = true;
        this.notificationDOMRef = React.createRef();

        // Bind own methods
        this.updateParentState = this.updateParentState.bind( this );

    }

    addNotification( inMessage, type ) {

        if ( !this.componentIsMounted ) {
            return;
        }

        this.notificationDOMRef.current.addNotification({
            title: '',
            message: inMessage,
            type: type || 'success',
            insert: 'top',
            container: 'top-right',
            animationIn: ['animated', 'fadeIn'],
            animationOut: ['animated', 'fadeOut'],
            dismiss: { duration: 2000 },
            dismissable: { click: true }
        });
    }

    updateParentState( newState ){
        this.setState( newState );
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {

        const selectedItem = nextProps[nextProps.activeTab + 'SelectedItem'];

        if ( selectedItem === 'loading' ) {
            nextState.scrollShowItems = nextState.scrollShowItemsDef;
            nextState.checkAllCtn = false;
            nextState.checkedItemCount = 0;
            nextState.checkedItems = {};

        } else if ( selectedItem !== '' && selectedItem.status === 'OK' ) {

            nextState.scrollItemCount = selectedItem.data.ctn_info[0].count;

        }

        return nextState;

    }

    componentWillUnmount() {

        this.componentIsMounted = false;
        this.notificationDOMRef = null;

    }

    infiniteScroll( event, count ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if (
            (event.target.scrollTop + event.target.offsetHeight > event.target.scrollHeight - 100) &&
            ( count > this.state.scrollShowItems )
        ) {

            this.setState({
                scrollShowItems: this.state.scrollShowItems + this.state.scrollLimit
            });
        }

    }

    info(){

        let result = '';
        const banInfo = ( this.props.activeTab === 'inn' ) ? this.props.innSelectedItem : this.props.banSelectedItem;

        if ( banInfo !== '' && banInfo.status === 'OK' && banInfo.data.hasOwnProperty('ban_info') ) {

            result = <B2bInfoList
                        banInfo={banInfo}
                        b2bTrans={this.props.b2bTrans}
                     />;
        } else if ( banInfo !== '' && banInfo.status === 'ERROR' ) {
            result = <p className="error-message">{banInfo.code}</p>
        }

        return result;

    }

    getExportLink(){

        const currentBan = this.props[this.props.activeTab + 'SelectedItem'];

        if ( currentBan === '' ) {
            return '';
        }

        if ( currentBan.status === 'OK' && currentBan.data.hasOwnProperty('ban_info') ) {

            return (
                <a
                    href={
                        '/api/' +
                        localStorageGetItem('defaultLngPrefix') + '/' +
                        this.props.urlPrefix + this.props.curator + '/getInfoByBan?' +
                        'ban=' + currentBan.data.ban_info.ban + '&' +
                        ((this.props.innVal === '' || this.props.innVal.length !== this.props.innMaxLength || this.props.innItems === '') ? '' : 'inn=' + this.props.innVal + '&') +
                        'jwt=' + this.props.getDecryptedToken() + '&action=export'
                    }
                    className="main-wrapper__bottom-export fs14 db fr sprite-a pr"
                    target="_blank"
                    rel="noopener noreferrer"
                >{trans(this.props.b2bTrans, 'b2b.ctn_list.export_title')}</a>
            );

        }

    }

    doSearch( ctns ){

        return ctns.reduce(( arr, item ) => {
            if ( item.ctn.toString().search( this.state.filterValForSearch ) > -1 ) {
                arr.push(item);
            }
            return arr;
        }, []);

    }

    showCreateAppBtn(){

        for ( const i in this.state.checkedItems ){

            if ( this.state.checkedItems[i] ) {
                return false;
            }

        }

        return true;

    }

    filterTop(){

        return (
            <div className="filter__top clear-fix">

                <form action="#" method="post" className="form form--search fl" onSubmit={( event ) => {
                    event.preventDefault();
                    this.setState({
                        filterValForSearch: this.state.filterVal,
                        scrollShowItems: this.state.scrollShowItemsDef
                    });
                }}>
                    <div className="form__form-box pr">
                        <input
                            className="form__field fs14"
                            type="text"
                            placeholder="Search"
                            value={this.state.filterVal}
                            onChange={( event ) => {

                                const newState = {
                                    filterVal: event.target.value.replace(/[^\d]/g, '')
                                };

                                if ( newState.filterVal === '' ) {
                                    newState['filterValForSearch'] = '';
                                    newState['scrollShowItems'] = this.state.scrollShowItemsDef;
                                }

                                this.setState( newState );

                            }}
                        />
                        <button className="form__search-btn sprite" type="submit">&nbsp;</button>
                    </div>
                </form>
                {
                    this.props.curator === 'curator' ?
                        <button
                            className="filter__btn btn btn--white fs17 fr"
                            type="button"
                            onClick={() => {
                                this.props.updateParentState({
                                    applicationData: Object.keys( this.state.checkedItems ),
                                    banSelectedTp: this.props.banSelectedItem.data.ban_info.plan
                                });
                                this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/createApplication' );
                                this.props.updatePath();
                            }}
                            disabled={this.showCreateAppBtn()}
                        >{trans( this.props.b2bTrans, 'b2b.create_application_title' )}</button> : null
                }
                {this.getExportLink()}

            </div>
        );

    }

    emptyFilter( message ){

        return (
            <tr>
                <td colSpan="5">
                    <p className="fs14 tc">{message}</p>
                </td>
            </tr>
        );

    }

    toggleCtn( ctn, stateCtn ){

        const newState = {};

        newState['ctn-' + ctn + '-Disabled'] = false;

        if ( stateCtn ) {

            ApiManager.getRequest({
                jwt: this.props.getDecryptedToken(),
                msisdn: ctn
            }, '/b2b/restoreCtn').then(( resolve ) => {

                // @test
                // resolve.data = { "status": "OK", "error": null, "data": { "status": "ok" } };
                // resolve.data = { "status": "ERROR" };

                if ( resolve.data.status === 'OK' ) {

                    this.addNotification( trans( this.props.b2bTrans, 'b2b.ctn.unblocked_success_message' ) );

                } else {
                    newState['ctn-' + ctn] = false;

                    let message = trans( this.props.b2bTrans, 'b2b.ctn.unblocked_error_message' );

                    if ( resolve.data.hasOwnProperty('message') ) {
                        message = resolve.data.message;
                    }

                    this.addNotification( message, 'danger' );
                }

                this.setState( newState );

            }, () => {
                newState['ctn-' + ctn] = false;
                this.setState( newState );
                this.props.updateParentState({ showErrorModal: true });
            });

        } else {

            ApiManager.getRequest({
                jwt: this.props.getDecryptedToken(),
                msisdn: ctn
            }, '/b2b/suspendCtn').then(( resolve ) => {

                // @test
                // resolve.data = { "status": "OK", "error": null, "data": { "status": "ok" } };
                // resolve.data = { "status": "ERROR" };

                if ( resolve.data.status === 'OK' ) {

                    this.addNotification( trans( this.props.b2bTrans, 'b2b.ctn.blocked_success_message' ) );

                } else {
                    newState['ctn-' + ctn] = true;

                    let message = trans( this.props.b2bTrans, 'b2b.ctn.blocked_error_message' );

                    if ( resolve.data.hasOwnProperty('message') ) {
                        message = resolve.data.message;
                    }

                    this.addNotification( message, 'danger' );

                }

                this.setState( newState );

            }, () => {
                newState['ctn-' + ctn] = true;
                this.setState( newState );
                this.props.updateParentState({ showErrorModal: true });
            });

        }

    }

    list(){

        let items = this.emptyFilter( trans( this.props.b2bTrans, 'b2b.ctn_list.filter_empty_result' ) );

        const banInfo = ( this.props.activeTab === 'inn' ) ? this.props.innSelectedItem : this.props.banSelectedItem;

        if (
            banInfo.status === 'OK' &&
            banInfo.data.hasOwnProperty('ctn_info') &&
            banInfo.data.ctn_info.length &&
            banInfo.data.ctn_info[0].hasOwnProperty('info') &&
            banInfo.data.ctn_info[0].info.hasOwnProperty('ctns') &&
            banInfo.data.ctn_info[0].count
        ) {

            let ctns = banInfo.data.ctn_info[0].info.ctns;

            if ( !ctns.length ) {
                ctns = [banInfo.data.ctn_info[0].info.ctns];
            }

            if ( this.state.filterValForSearch ) {
                ctns = this.doSearch( ctns );
            }

            items = ctns.reduce(( arr, item, index ) => {

                if ( index + 1 > this.state.scrollShowItems ) {
                    return arr;
                }

                const ctnIsBlocked = ( typeof this.state['ctn-' + item.ctn] !== 'undefined' ? this.state['ctn-' + item.ctn] : item.ctn_status === 'A' );

                arr.push(
                    <tr key={index}>
                        {this.props.curator === 'curator' ?
                            <td className="filter__first-cell">
                                <input
                                    className="form__switcher-checkbox dn"
                                    name={`app-number-${item.ctn}`}
                                    id={`app-number-${item.ctn}`}
                                    type="checkbox"
                                    checked={this.state.checkedItems[item.ctn] || false}
                                    onChange={() => {
                                        const newState = {
                                            checkedItemCount: 0,
                                            checkedItems: this.state.checkedItems
                                        };

                                        if ( this.state.checkedItems.hasOwnProperty( item.ctn ) ) {
                                            newState['checkedItems'][item.ctn] = !this.state.checkedItems[item.ctn];
                                            newState['checkedItemCount'] = newState['checkedItems'][item.ctn] ? this.state.checkedItemCount + 1 : this.state.checkedItemCount - 1;
                                        } else {
                                            newState['checkedItems'][item.ctn] = true;
                                            newState['checkedItemCount'] = this.state.checkedItemCount + 1;
                                        }

                                        newState['checkAllCtn'] = newState['checkedItemCount'] === this.state.scrollItemCount;

                                        this.setState( newState );

                                    }}
                                />
                                <label
                                    className="form__switcher ver-top-box fs12 sprite-a pr select-none"
                                    htmlFor={`app-number-${item.ctn}`}
                                ></label>
                            </td> : null
                        }
                        <td className="fs14">+374 {setBracketsAfterFirstPart( item.ctn.toString().replace(/^74/, '') )}</td>
                        <td className="fs14">{item.pp}</td>
                        <td className="fs14">{item.activity_description}</td>
                        <td>
                            <input
                                className="form__checkbox dn"
                                id={`ctn-${index}`}
                                type="checkbox"
                                checked={ctnIsBlocked}
                                onChange={() => {

                                    const newState = {};
                                    let stateCtn = this.state['ctn-' + item.ctn];

                                    if ( typeof stateCtn === 'undefined' ) {
                                        stateCtn = item.ctn_status !== 'A';
                                    } else {
                                        stateCtn = !stateCtn;
                                    }

                                    newState['ctn-' + item.ctn] = stateCtn;
                                    newState['ctn-' + item.ctn + '-Disabled'] = true;

                                    this.setState( newState );
                                    this.toggleCtn( item.ctn, stateCtn );

                                }}
                                disabled={this.state['ctn-' + item.ctn + '-Disabled']}
                            />
                            <label
                                className="form__check-label form__check-label--toggle sprite-a pr db"
                                htmlFor={`ctn-${index}`}
                                title={trans( this.props.b2bTrans, 'b2b.ctn_' + ( ctnIsBlocked ? '' : 'un' ) + 'block_title' )}
                            >&nbsp;</label>
                        </td>
                        <td>
                            <Link
                                className="filter__more ver-top-box sprite-a pr"
                                to={
                                    config.urlPrefix +
                                    this.props.urlPrefix + '/' +
                                    this.props.activeTab + '/' +
                                    ( this.props.activeTab === 'inn' ? this.props.innVal + '/ban/' + this.props.innActiveBan + '/' : '' ) +
                                    ( this.props.activeTab === 'ban' ? this.props.banVal + '/' : '' ) +
                                    'ctn/' + item.ctn
                                }
                                onClick={() => {
                                    const newState = {};
                                    newState[this.props.activeTab + 'ActiveCtnView'] = true;
                                    newState[this.props.activeTab + 'ActiveCtn'] = item.ctn;

                                    this.props.updateParentState( newState );
                                    this.props.getInfoByCtn( item.ctn );
                                }}
                            >{trans(this.props.b2bTrans, 'b2b.ctn_list.more_title')}</Link>
                        </td>
                    </tr>
                );

                return arr;

            }, []);

            if ( !items.length ) {
                items = this.emptyFilter( trans( this.props.b2bTrans, 'b2b.ctn_list.filter_no_result' ) );
            }

        }

        return (
            <div className="filter">

                {this.filterTop()}

                <div className="filter__content scroller-block">
                    <table className="filter__table">
                        <thead>
                            <tr>
                                {this.props.curator === 'curator' ?
                                    <th className="filter__first-cell">
                                        <input
                                            className="form__switcher-checkbox dn"
                                            name="check-all"
                                            id="check-all"
                                            type="checkbox"
                                            checked={this.state.checkAllCtn}
                                            onChange={() => {

                                                const newState = {
                                                    checkedItems: {},
                                                    checkAllCtn: !this.state.checkAllCtn
                                                };

                                                newState['checkedItemCount'] = newState.checkAllCtn ? this.state.scrollItemCount : 0;

                                                if ( newState.checkAllCtn ) {

                                                    const banInfo = ( this.props.activeTab === 'inn' ) ? this.props.innSelectedItem : this.props.banSelectedItem;
                                                    const ctns = banInfo.data.ctn_info[0].info.ctns;

                                                    for ( const i in ctns ) {
                                                        newState['checkedItems'][ctns[i]['ctn']] = true;
                                                    }

                                                }

                                                this.setState( newState );

                                            }}
                                        />
                                        <label
                                            className="form__switcher ver-top-box fs12 sprite-a pr select-none"
                                            htmlFor="check-all"
                                        >{trans(this.props.b2bTrans, 'b2b.ctn_list.toggle_all_title')}</label>
                                    </th> : null
                                }
                                <th className="fs12">{trans(this.props.b2bTrans, 'b2b.ctn_list.number_title')}</th>
                                <th className="fs12">{trans(this.props.b2bTrans, 'b2b.ctn_list.plan_title')}</th>
                                <th className="fs12">{trans(this.props.b2bTrans, 'b2b.ctn_list.status_title')}</th>
                                <th>&nbsp;</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>

            </div>
        );

    }

    view(){

        let view = this.info();
        const activeTabIndex = this.props[this.props.activeTab + 'ActiveTabIndex'];
        const activeTabCtnView = this.props[this.props.activeTab + 'ActiveCtnView'];
        const ctnActiveItems = this.props[this.props.activeTab + 'BoxCtnItems'];

        if ( activeTabIndex === 1 && !activeTabCtnView ) {
            view = this.list();
        } else if ( activeTabIndex === 1 && activeTabCtnView ) {

            if ( ctnActiveItems === '' ) {
                return <Loading withBox={true} />;
            }

            view = <B2bCtnView
                       innVal={this.props.innVal}
                       innBoxCtnItems={this.props.innBoxCtnItems}
                       innSelectedItem={this.props.innSelectedItem}
                       innActiveTabIndex={this.props.innActiveTabIndex}
                       innActiveCtnView={this.state.innActiveCtnView}

                       banActiveCtnView={this.props.banActiveCtnView}
                       banBoxCtnItems={this.props.banBoxCtnItems}
                       banSelectedItem={this.props.banSelectedItem}
                       banActiveTabIndex={this.props.banActiveTabIndex}
                       banVal={this.props.banVal}

                       ctnBoxCtnItems={this.props.ctnBoxCtnItems}
                       ctnActiveCtnView={this.props.ctnActiveCtnView}
                       ctnActiveTabIndex={this.props.ctnActiveTabIndex}

                       b2bTrans={this.props.b2bTrans}
                       profileData={this.props.profileData}
                       updateParentState={this.props.updateParentState}
                       urlPrefix={this.props.urlPrefix}
                       activeTab={this.props.activeTab}
                       history={this.props.history}
                       getDecryptedToken={this.props.getDecryptedToken}
                       csrf_token={this.props.csrf_token}
                       curator={this.props.curator}
                   />;
        }

        return view;

    }

    menu(){

        return (
            <>

                <ul className="main-wrapper__right-menu">
                    <li className="main-wrapper__right-menu-item ver-top-box">
                        <button
                            type="button"
                            className={`main-wrapper__right-menu-link db monserrat-medium pr${this.props[this.props.activeTab + 'ActiveTabIndex'] === 0 ? ' main-wrapper__right-menu-link--active' : ''}`}
                            onClick={() => {
                                const newState = {};

                                newState[this.props.activeTab + 'ActiveTabIndex'] = 0;
                                this.props.updateParentState( newState );

                            }}
                        >{trans(this.props.b2bTrans, 'b2b.ban_tab.info_title')}</button>
                    </li>
                    <li className="main-wrapper__right-menu-item ver-top-box">
                        <button
                            type="button"
                            className={`main-wrapper__right-menu-link db monserrat-medium pr${this.props[this.props.activeTab + 'ActiveTabIndex'] === 1 ? ' main-wrapper__right-menu-link--active' : ''}`}
                            onClick={() => {

                                const banInfo = ( this.props.activeTab === 'inn' ) ? this.props.innSelectedItem : this.props.banSelectedItem;
                                let scrollItemCount = 0;

                                if (
                                    banInfo.status === 'OK' &&
                                    banInfo.data.hasOwnProperty('ctn_info') &&
                                    banInfo.data.ctn_info.length &&
                                    banInfo.data.ctn_info[0].count
                                ) {
                                    scrollItemCount = banInfo.data.ctn_info[0].count;
                                }

                                this.setState({
                                    scrollItemCount
                                });

                                const newState = {};

                                newState[this.props.activeTab + 'ActiveTabIndex'] = 1;
                                this.props.updateParentState( newState );
                            }}
                        >{trans(this.props.b2bTrans, 'b2b.ban_tab.list_title')}</button>
                    </li>
                </ul>

            </>
        );

    }

    notificationRender(){

        if ( !this.componentIsMounted ) {
            return;
        }

        return (
            <ReactNotification ref={this.notificationDOMRef} />
        );

    }

    render(){

        if ( ( this.props.activeTab === 'inn' && this.props.innSelectedItem === 'loading' ) || ( this.props.activeTab === 'ban' && this.props.banSelectedItem === 'loading' ) ) {
            return <Loading />;
        }

        return(
            <div className="main-wrapper__right-inner main-wrapper__right-inner--list scroller-block pr" onScroll={( event ) => this.infiniteScroll( event, this.state.scrollItemCount )}>
                {this.notificationRender()}
                <div className="main-wrapper__right-content">
                    {this.menu()}
                    {this.view()}
                </div>
            </div>
        );

    }

}

export default B2bBanInfo;